import { useLayoutEffect } from "react";

import useCurrentEnvironment from "./use-environment";
import usePrevious from "./use-previous";

// This is a hook used for running a function when a user picks a new environment.
// It doesn't run when the environment is initially loaded on the page.
function useOnEnvironmentChangedByUser(callback: Function) {
  const currentEnvironment = useCurrentEnvironment();
  const previousCurrentEnvironment = usePrevious(currentEnvironment);

  // Using layout effect in case the callback function needs to update refs.
  // If callback is async, this ends up just being the same as useEffect, but if callback is sync, the component won't
  // re-render until the callback is complete.
  useLayoutEffect(() => {
    if (
      previousCurrentEnvironment &&
      // @ts-ignore
      previousCurrentEnvironment.loaded &&
      // @ts-ignore
      previousCurrentEnvironment.ID !== currentEnvironment.ID
    ) {
      // When the environment changes
      callback(currentEnvironment);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEnvironment, callback]);
}

export default useOnEnvironmentChangedByUser;
